import { IModelSettings } from '../types/modelSettings';

export const modelSettings: IModelSettings = {
  'flux-kitchen': {
    input: {
      steps: 28,
      output_quality: 100,
      guidance_scale: 3.5,
      lora: 'interior-v1',
      control_type: 'depth',
      lora_strength: 1,
      depth_preprocessor: 'DepthAnything',
      negative_prompt: 'low quality, ugly, distorted, artefacts',
      control_strength: 0.75,
      image_to_image_strength: 0.01,
      return_preprocessed_image: false,
    },
    styles: [
      {
        label: 'Shaker door style in white/marble countertop',
        value: 'white_shaker_cabinets',
      },
      {
        label: 'Frameless door style in white/grey countertop',
        value: 'white_frameless_cabinets',
      },
      {
        label: 'Frameless door style in black/grey countertop',
        value: 'black_frameless_cabinets',
      },
      {
        label: 'Shaker door style in grey/marble countertop',
        value: 'grey_shaker_cabinets',
      },
      {
        label: 'Shaker door style in blue/marble countertop',
        value: 'blue_shaker_cabinets',
      },
      {
        label: 'Shaker door style in green/marble countertop',
        value: 'green_shaker_cabinets',
      },
      {
        label: 'Frameless door style in wood/marble countertop',
        value: 'wood_frameless_cabinets',
      },
      { label: 'None', value: 'none' },
    ],
    presets: [
      {
        label: 'Modern Kitchen',
        prompt:
          'A modern kitchen with white shaker cabinets, quartz countertops, and stainless steel appliances. Large windows letting in natural light. Hardwood floors and pendant lighting over the island.',
      },
    ],
  },
  'flux-bedroom': {
    input: {
      steps: 28,
      output_quality: 100,
      guidance_scale: 3.5,
      lora: 'bedroom-v1',
      control_type: 'depth',
      lora_strength: 1,
      depth_preprocessor: 'DepthAnything',
      negative_prompt: 'low quality, ugly, distorted, artefacts',
      control_strength: 0.75,
      image_to_image_strength: 0.01,
      return_preprocessed_image: false,
    },
    styles: [
      {
        label: 'Upholstered bed in beige, white linens, blackout curtains',
        value: 'beige_upholstered_white_linens_bedroom',
      },
      {
        label: 'Wooden bed in walnut, dark green bedding, boho rug',
        value: 'walnut_wood_green_bedding_bedroom',
      },
      {
        label: 'Minimalist platform bed, gray linens, sheer curtains',
        value: 'minimalist_gray_sheer_bedroom',
      },
      {
        label: 'Canopy bed in black, white/gold bedding, velvet drapes',
        value: 'black_canopy_gold_bedding_bedroom',
      },
      {
        label: 'Light oak bed, pastel linens, Scandinavian style',
        value: 'light_oak_pastel_scandi_bedroom',
      },
      { label: 'None', value: 'none' },
    ],
    presets: [
      {
        label: 'Cozy Bedroom',
        prompt:
          'A cozy bedroom with a large bed, soft bedding, and warm lighting. Wooden furniture, a small reading nook by the window, and subtle decorative elements.',
      },
    ],
  },
  'flux-livingroom': {
    input: {
      steps: 28,
      output_quality: 100,
      guidance_scale: 3.5,
      lora: 'livingroom-v1',
      control_type: 'depth',
      lora_strength: 1,
      depth_preprocessor: 'DepthAnything',
      negative_prompt: 'low quality, ugly, distorted, artefacts',
      control_strength: 0.75,
      image_to_image_strength: 0.01,
      return_preprocessed_image: false,
    },
    styles: [
      {
        label: 'Beige sofa, white cushions, light gray walls, modern style',
        value: 'beige_modern_livingroom',
      },
      // {
      //   label: 'Walnut wood furniture, dark green accents, terracotta walls, boho style',
      //   value: 'walnut_boho_livingroom',
      // },
      {
        label: 'Minimalist sofa, gray cushions, white walls, Scandinavian style',
        value: 'minimal_scandi_livingroom',
      },
      {
        label: 'Black velvet sofa, gold accents, navy blue walls, luxury style',
        value: 'velvet_luxury_livingroom',
      },
      { label: 'None', value: 'none' },
    ],
    presets: [
      {
        label: 'Cozy Living Room',
        prompt:
          'A cozy living room with a comfortable sofa, soft cushions, and warm ambient lighting. Wooden coffee table, a small bookshelf by the wall, and subtle decorative elements like plants and framed pictures.',
      },
    ],
  },
  'flux-exterior': {
    input: {
      steps: 28,
      output_quality: 100,
      guidance_scale: 3.5,
      lora: 'exterior-v1',
      control_type: 'depth',
      lora_strength: 1,
      depth_preprocessor: 'DepthAnything',
      negative_prompt: 'low quality, ugly, distorted, artefacts',
      control_strength: 0.75,
      image_to_image_strength: 0,
      return_preprocessed_image: false,
    },
    styles: [
      {
        value: 'white_painted',
        label: 'White Painted',
      },
      {
        value: 'white_wood',
        label: 'White Wood Siding',
      },
      {
        value: 'combined_white_wood',
        label: 'Combined White Painted and Natural Wooden Siding',
      },
      {
        value: 'yellow_wood',
        label: 'Yellow Nature Wood Siding',
      },
      {
        value: 'blue_wood',
        label: 'Light Blue Wood Siding',
      },
      {
        value: 'green_wood',
        label: 'Light Green Wood Siding',
      },
      {
        label: 'Tudor style',
        value: 'tudor_style',
      },
      {
        value: 'none',
        label: 'None',
      },
    ],
    presets: [
      {
        label: 'Modern Farmhouse',
        prompt:
          'A modern farmhouse exterior black windows, and a metal roof. A covered porch with wooden columns, and simple landscaping with native plants.',
      },
      {
        label: 'Contemporary Home',
        prompt:
          'A contemporary home with clean lines, large windows, and a mix of materials including wood, concrete, and metal. Minimalist landscaping and a flat or low-pitched roof.',
      },
      {
        label: 'Traditional Cottage',
        prompt:
          'A traditional cottage with stone and wood siding, a pitched roof with asphalt shingles, and charming details like shutters and a covered entry. Surrounded by lush gardens and a stone pathway.',
      },
    ],
  },
  kontext: {
    input: {},
    prompt:
      'Make an California backyard environment around the original house - greens, lush trees, lawn, fence on the both sides, strictly straight cozy path for people with slabs spaced apart to the entrance. Just add the surroundings while keeping the house.',
    presets: [
      {
        label: 'Exterior environment',
        prompt:
          'Create an California backyard environment around the original house - lush greens, lush trees, lawn, fence on the both sides, strictly straight cozy path for people with slabs spaced apart to the entrance. Just add the surroundings while keeping the house.',
      },
      {
        label: 'Exterior environment 2',
        prompt:
          'Make an California backyard environment around the original house - greens, lush trees, lawn, fence on the both sides, strictly straight cozy path for people with slabs spaced apart to the entrance. Just add the surroundings while keeping the house.',
      },
      {
        label: 'Replace the path',
        prompt:
          'Replace the existing path to the house with a cozy path for people with slabs spaced apart and grass between the slabs. All in the California style.',
      },
      {
        label: 'Replace and move the path',
        prompt:
          'Replace and move to entrance the existing path to the house with a cozy path for people with slabs spaced apart and grass between the slabs. All in the California style.',
      },
    ],
  },
  upscaler: {
    input: {},
    prompt: '',
  },
  'nano-banana': {
    input: {},
    prompt: '',
    presets: [
      {
        label: 'Gable roof',
        prompt: 'Make the roof gable',
      },
      {
        label: 'Change walls color (to green)',
        prompt: 'edit the walls of the house with light green horizontal wood siding.',
      },
      {
        label: 'Change walls color (to blue)',
        prompt: 'edit the walls of the house with light blue horizontal wood siding.',
      },
      {
        label: 'Change walls color (to yellow)',
        prompt: 'edit the walls of the house with light yellow horizontal wood siding.',
      },
      {
        label: 'Modern Farmhouse with porch',
        prompt: `Change style of the house to the cute Modern Farmhouse. 
Change the exterior walls to horizontal board-and-batten siding, painted clean white with subtle shadow lines and realistic depth. 
Keep the windows with true black frames and reflective glass. 
Add natural warm-toned wooden beams and posts on the porch structure, with visible wood grain and knots for authenticity. Change the porch a little bigger with a couple of chairs.`,
      },
      {
        label: 'Modern Farmhouse style',
        prompt: 'Change style of the house to the Modern Farmhouse.',
      },
      {
        label: 'Exterior ONLY ONE IMAGE',
        prompt: `Use the provided architectural sketch of the house as the base: it defines the shape, proportions, and frontal composition. 
Re-draw it as an ultra-photorealistic DSLR photograph taken in a California backyard.
Ensure the house has a proper pitched roof with realistic shingles, visible depth, and accurate eaves with natural overhangs. Windows must be rendered with true black frames and reflective glass. The facade should be finished in white horizontal siding with subtle shadow lines and micro-variation for realism.
Above the house, large mature trees should overhang slightly, casting dappled natural shadows across the roof and facade. At the entrance, add warm and cozy exterior details, such as wall-mounted lantern sconces (bra) on both sides of the front door, subtle trim details, and a welcoming porch finish.
Place the house naturally in a California backyard with a stone or concrete walkway leading toward the entrance, surrounded by lush landscaping: lavender, rosemary, mature trees, and a photorealistic lawn. Neighbor houses and fences should be faintly visible through the foliage for authentic suburban context.
The lawn must look lifelike: individual blades of grass with uneven heights, color variation, occasional brown tips, and soil patches. Add natural imperfections: debris on the walkway, faint dirt at the siding base, realistic cracks in concrete, and subtle weathering.
Lighting and color should follow the clean, bright style of a clear midday scene: soft diffused daylight, neutral to slightly cool balance, crisp but gentle shadows, and dappled shade from trees. 
Camera: Canon EOS R5, 35mm lens, ~f/8 for full facade sharpness, tripod stability. Subtle lens imperfections only (very mild chromatic aberration, natural film grain).
Final output must look like a ultra realistic captured photograph.  Keep a straight-on frontal perspective and professional real-estate photo quality.
-- Output format: square image (1:1 aspect ratio), high resolution.`,
      },
      {
        label: 'Exterior with ref images',
        prompt: `Use the first image as the base architectural sketch: it defines the house’s shape, proportions, and frontal composition.
Re-draw it as an ultra-photorealistic DSLR photograph taken in a California backyard.
Use the following reference images only as sources for architectural details (such as roof form, porch design, window placement, trim shapes, and other structural elements). Do not transfer their colors, materials, or textures. All surfaces and finishes must remain consistent with the design intent: white siding with subtle shadow lines and micro-variation, black window frames with realistic reflections, and a pitched roof with natural shingles and slight wear.
Place the house naturally in a California backyard with a stone or concrete walkway leading toward the entrance, surrounded by lush landscaping: lavender, rosemary, mature trees, and a realistic lawn. Neighbor houses and fences should be faintly visible through the foliage for authentic suburban context.
The lawn must look photorealistic: individual grass blades with uneven heights, color variation, occasional brown tips, and soil patches. Add natural imperfections: debris on the walkway, faint dirt at the siding base, realistic cracks in concrete, and subtle weathering.
Lighting and color should follow the clean, bright style of a clear midday scene: soft diffused daylight, neutral to slightly cool balance, crisp but gentle shadows, and dappled shade from trees. 
Camera: Canon EOS R5, 35mm lens, ~f/8 for full facade sharpness, tripod stability. Subtle lens imperfections only (very mild chromatic aberration, natural film grain).
Final output must look like a real captured photograph, not CGI. No plastic or painted textures, no over-sharpening, no HDR glow, no toon shading, no stylization. Keep a straight-on frontal perspective and professional real-estate photo quality.
-- Output format: square image (1:1 aspect ratio), high resolution.`,
      },
      {
        label: 'Kitchen with white cabinets',
        prompt: `Ultra-photorealistic interior real-estate photo of a bright cozy classic-style kitchen based on the provided sketch. White paneled cabinetry with a slightly glossy painted finish and black handles. Wooden countertops in a warm natural tone with visible wood grain and satin sheen. White ceramic farmhouse sink. Glossy white subway tile backsplash with beveled edges and subtle grout lines. Flooring is large light ceramic tiles in a geometric pattern with darker contrasting inserts, matte surface, and realistic texture variation. Glass-front upper cabinets with realistic reflections, faintly visible dishware inside. Built-in modern black oven and a four-burner gas cooktop with realistic metal grates, seamlessly integrated into the countertop. Above the cooktop, a black range hood integrated into the upper cabinetry, with subtle reflections and depth. Lighting is natural diffused daylight, soft and even, creating gentle shadows. Ceiling lighting consists of recessed spotlights flush with the ceiling. Everyday kitchen details included for authenticity, all arranged naturally to make the space feel warm and lived-in. Straight verticals, no keystone distortion, professional real-estate photo quality. Square format, high resolution.`,
      },
      {
        label: 'Kitche with green cabinets',
        prompt:
          'Ultra-photorealistic interior real-estate photo of a bright cozy classic-style kitchen based on the provided sketch. Matte sage green cabinetry with clean shaker-style fronts and slim brass handles. White marble-look quartz countertops with subtle gray veining and a matching full-height marble backsplash. Integrated black glass electric cooktop with sleek flush finish. Minimalist matte black faucet and undermount sink. Flooring is large polished ceramic tiles in a light gray tone with natural marble-like veining. Glass-front upper cabinets with realistic reflections, faintly visible dishware inside. Built-in modern black oven and a four-burner gas cooktop with realistic metal grates, seamlessly integrated into the countertop. Above the cooktop, a black range hood integrated into the upper cabinetry, with subtle reflections and depth. Lighting is natural diffused daylight, soft and even, creating gentle shadows. Ceiling lighting consists of recessed spotlights flush with the ceiling. Everyday kitchen details included for authenticity, all arranged naturally to make the space feel warm and lived-in. Straight verticals, no keystone distortion, professional real-estate photo quality. Square format, high resolution.',
      },
      {
        label: 'Kitchen with black cabinets',
        prompt:
          'Ultra-photorealistic interior real-estate photo of a bright cozy classic-style kitchen based on the provided sketch. Matte black cabinets with clean shaker-style fronts and slim brass handles. White marble-look quartz countertops with subtle gray veining and a matching full-height marble backsplash. Integrated black glass electric cooktop with sleek flush finish. Minimalist matte black faucet and undermount sink. Flooring is hardwood beige in a light tone. Glass-front upper cabinets with realistic reflections, faintly visible dishware inside. Built-in modern black oven and a four-burner gas cooktop with realistic metal grates, seamlessly integrated into the countertop. Above the cooktop, a black range hood integrated into the upper cabinetry, with subtle reflections and depth. Lighting is natural diffused daylight, soft and even, creating gentle shadows. Ceiling lighting consists of recessed spotlights flush with the ceiling. Everyday kitchen details included for authenticity, all arranged naturally to make the space feel warm and lived-in. Straight verticals, no keystone distortion, professional real-estate photo quality. Square format, high resolution.',
      },
      {
        label: 'Bedroom in farmhouse style with wooden beams',
        prompt:
          'Ultra-photorealistic interior real-estate photo of a bright cozy natural-style bedroom based on the provided sketch. Warm natural wood elements with visible grain in a light oak tone. Soft neutral wall finish in light beige with subtle texture. Ceiling with exposed wooden beams and light-toned wood paneling. Flooring is hardwood in a medium natural tone with matte finish. Textiles in calm earthy shades: beige, sand, cream, and muted gray. Woven natural fiber elements adding texture and warmth. Large window openings, if present, feature light flowing curtains in neutral tones, adding softness and natural depth. Lighting is natural diffused daylight filling the room evenly, creating soft shadows and a serene atmosphere. Ceiling lighting consists of recessed spotlights flush with the ceiling. Everyday bedroom details included for authenticity, arranged naturally to make the space feel warm, calm, and lived-in. Straight verticals, no keystone distortion, professional real-estate photo quality. Square format, high resolution.',
      },
      {
        label: 'Bedroom with white walls in light tones',
        prompt:
          'Ultra-photorealistic interior real-estate photo of a bright cozy minimalist bedroom based on the provided sketch. Walls in soft warm white with a smooth matte finish. Light natural wood elements with a clean modern look. Flooring in neutral beige carpet with fine texture. Bed textiles in fresh white cotton with soft natural folds, accented by pillows and blankets in muted earthy tones such as deep green and cream. Curtains in layered fabrics: sheer white for softness and light beige for depth, creating a calm airy atmosphere. Lighting is natural diffused daylight entering through the window, filling the room evenly with soft shadows. Ceiling lighting consists of recessed spotlights flush with the ceiling. Subtle natural details like simple framed art, greenery, and minimal decor add warmth and serenity. Straight verticals, no keystone distortion, professional real-estate photo quality. Square format, high resolution.',
      },
      {
        label: 'Bedroom with blue walls',
        prompt:
          'Ultra-photorealistic interior real-estate photo of a modern cozy bedroom based on the provided sketch. Walls painted in a deep matte navy blue creating a dramatic and elegant atmosphere. Warm mid-century style furniture in natural walnut wood tones with clean lines and tapered legs. Flooring is hardwood in a medium warm tone with subtle natural grain. Bed textiles layered in white, soft gray, and multiple shades of blue, from navy to denim, creating depth and richness. Accents of brass and gold in lighting and decor elements add a touch of sophistication. Curtains in soft neutral fabric allowing daylight to diffuse naturally. Lighting is natural diffused daylight, complemented by subtle warm accent lamps and modern pendant fixtures. Decorative accents like abstract artwork, ceramic vases, and plants enhance the character of the space. Straight verticals, no keystone distortion, professional real-estate photo quality. Square format, high resolution.',
      },
      {
        label: 'Living room with white walls',
        prompt:
          'Ultra-photorealistic interior real-estate photo of a bright cozy modern living room based on the provided sketch. Walls in smooth matte white with a clean finish. Flooring in wide-plank hardwood in a medium warm tone with natural grain variation. Large contemporary sectional sofa in a light neutral fabric, soft and inviting, styled with accent pillows in earthy shades like terracotta, rust, beige, and muted patterns. A sleek wooden coffee table with clean lines and warm walnut tone, styled with a mix of books, ceramics, and a simple vase with dried or natural greenery for balance. A large textured area rug in soft beige tones grounding the space. Decorative abstract artwork framed on the walls adding modern character and depth. Lighting is natural diffused daylight from large windows, complemented by warm modern ceiling fixtures and minimalist floor lamps. Subtle greenery and organic elements enhance the cozy atmosphere. All objects arranged with harmony and balance to look refined, warm, and lived-in. Straight verticals, no keystone distortion, professional real-estate photo quality. Square format, high resolution.',
      },
      {
        label: 'Living room with white walls and greenery',
        prompt:
          'Ultra-photorealistic interior real-estate photo of a bright eclectic modern living room based on the provided sketch. Walls in soft matte white with a clean smooth finish. Flooring in natural hardwood with warm undertones and visible grain. Comfortable sofas in neutral tones with accent pillows in earthy and muted colors, creating a layered cozy look. A woven rattan or wicker coffee table in a natural finish, styled with books, ceramics, and small plants. A large textured rug in a bold deep color grounding the room. Built-in shelving in white with a curated mix of books, ceramics, baskets, framed art, and small decorative objects, arranged naturally but tastefully. Lighting is natural diffused daylight from large windows and glass doors, filling the room with brightness and soft shadows. Ceiling lighting kept subtle with recessed fixtures. Decorative accents include colorful artwork, organic shapes, and greenery that bring warmth and personality without clutter. All objects arranged harmoniously to create a welcoming, lived-in, and stylish space. Straight verticals, no keystone distortion, professional real-estate photo quality. Square format, high resolution.',
      },
      {
        label: 'Living room with navy blue walls',
        prompt:
          'Ultra-photorealistic interior real-estate photo of a sophisticated modern living room based on the provided sketch. Composition captured with professional real-estate photography: straight verticals, balanced perspective, natural eye-level view, no keystone distortion. Walls in deep matte navy blue creating an elegant accent backdrop. Flooring in natural hardwood in a warm medium oak tone with visible grain variation. Comfortable sofas in light neutral fabrics such as cream or soft beige, styled with accent pillows in dark navy, geometric patterns, and muted earthy tones for balance. A sleek wooden coffee table in rich walnut with slim black metal legs, styled with books, ceramics, and a small vase with greenery. A large textured woven rug in light beige grounding the room. Window openings feature flowing light curtains in off-white tones, softly diffusing natural daylight into the space. Lighting is natural, bright yet gentle, with warm subtle ceiling fixtures adding refinement. Decorative accents include botanical framed artwork, fresh greenery, and simple ceramics, arranged harmoniously for a clean, stylish, and inviting look. Square format, high resolution, final output must look like an ultra-realistic captured photograph.',
      }
    ],
  },
};

export const modelOptions = [
  { value: 'nano-banana', label: 'Nano Banana' },
  { value: 'kontext', label: 'Flux kontext' },
  { value: 'upscaler', label: 'Upscale image' },
  { value: 'flux-exterior', label: 'Exterior' },
  { value: 'flux-kitchen', label: 'Kitchen' },
  { value: 'flux-bedroom', label: 'Bedroom' },
  { value: 'flux-livingroom', label: 'Living room' },
];
